(function(){
    angular
        .module('maApp.validation')
        .directive('pbLessThanOrEqualTo', pbLessThanOrEqualTo);

    pbLessThanOrEqualTo.$inject = [];

    function pbLessThanOrEqualTo(){
        return {
            require: 'ngModel',
            link: function(scope, elm, attrs, ctrl) {

                ctrl.$validators.pbLessThanOrEqualTo = pbLessThanOrEqualToValidator;

                function pbLessThanOrEqualToValidator(modelValue, viewValue) {

                    var ltOrEq = scope.$eval(attrs['pbLessThanOrEqualTo']);

                    if(!ltOrEq){
                        return true;        //valid if  there is no value to compare against
                    }

                    return parseInt(modelValue) <= ltOrEq;

                }
            }
        };
    }
})();